export default __webpack_public_path__ + "static/vyzkum-506132613915756d652a179c77a13fe0.png";